import checkmarkIcon from 'assets/icons/icon-checkmark-copied-16.svg';
import clipboardIcon from 'assets/icons/icon-clipboard-16.svg';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../button';
import { Tooltip } from '../tooltip';

interface Props {
  description?: React.ReactNode;
  content?: string;
}

export const ClipboardButton: React.FC<Props> = ({ description, content }) => {
  const [copied, setCopied] = useState(false);

  function copyToClipboard() {
    if (!content) return;
    navigator?.clipboard.writeText(content);
    setCopied(true);
  }

  useEffect(() => {
    if (!copied) return;

    const timeoutId = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [copied]);

  return (
    <div className="clipboard__container">
      <p className="t-text-1 t-bold text--xs__responsive">{description}</p>
      <div
        className="f f--align-center clipboard__customer__id"
        data-cy="customer-id"
      >
        <span className="text--xs t-text-1"> {content}</span>
        <Button type="button" className="btn__slim">
          <Tooltip
            onClick={copyToClipboard}
            iconPath={copied ? checkmarkIcon : clipboardIcon}
            messageId={
              copied
                ? 'settings.subscription.customer-id.copied'
                : 'settings.subscription.customer-id.tooltip'
            }
            iconClassName="clipboard"
            tooltipClassName={`tooltip ${copied && 'tooltip--copied'}`}
          />
        </Button>
      </div>
      <span className="text--xxs__responsive t-text-3 u-width--full">
        <FormattedMessage id="settings.subscription.customer-id-clipboard-description" />
      </span>
    </div>
  );
};
